import AuthService from '../services/AuthService';

export function authHeader(): Headers {
  const token = AuthService.getToken();
  const mHeaders = new Headers();

  if (token) {
    mHeaders.append('X-Auth-Token', `${token}`);
  }
  mHeaders.append('Content-Type', 'application/json');

  return mHeaders;
}
